export default __webpack_public_path__ + "static/media/messageInfo16.3f67e6a2.svg";